module.exports = __webpack_public_path__ + "logo_ru.png?0550a457832c1bdac6d981584b320a78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_ru.png
// module id = 219
// module chunks = 0